'use strict';

(function () {
  'use strict';

  angular.module('referrals').controller('ReferralCtrl', ReferralCtrl);

  ReferralCtrl.$inject = ['$stateParams', '$state', '$document', 'user', 'providerSvc', 'referralSvc', 'domainSvc', '$translate', 'languageSvc', 'errorRouter'];

  /* @ngInject */
  function ReferralCtrl($stateParams, $state, $document, user, providerSvc, referralSvc, domainSvc, $translate, languageSvc, errorRouter) {
    var vm = this;
    vm.select = _select;
    vm.goAgain = _goAgain;
    vm.complete = _complete;
    vm.returnToList = _returnToList;
    vm.isLoggedIn = !!user;
    vm.user = user;
    vm.returnUrl = domainSvc.getRelativeUrl($stateParams.returnurl || '/login');
    vm.$onInit = activate;

    function activate() {

      if (!$stateParams.organization) {
        errorRouter.navigate404();
      } else {
        // Get the referral settings for the Org in the URL, or go to the error page.
        referralSvc.getReferralOrgReferralSettings($stateParams.organization).then(function (resp) {
          vm.referralSettingsList = resp;
          vm.showList = _hasOnlyOrgReferral(resp);
          //set the provider and attempt to resolve view state
          _validateProvider().then(function (resp) {
            return resp.data ? _initProvider() : _onInvalidForm();
          });
        }, function () {
          return _onInvalidForm();
        });
      }
      if (vm.isLoggedIn && !$stateParams.returnurl) {
        // If the user is logged in, change the returnUrl from '/login' to their provider's defaultDestinationUri. fall back to '/v'.
        vm.returnUrl = domainSvc.getRelativeUrl(_.get(vm.user, 'providerPreferences.defaultDestinationUri') || '/v');
      }
    }

    function _validateProvider() {
      return providerSvc.validateProvider({
        organization: $stateParams.organization,
        group: $stateParams.group,
        accessCode: $stateParams.pc
      });
    }

    function _hasOnlyOrgReferral(referralSettingsList) {
      return referralSettingsList.filter(function (r) {
        return r.settings.accessLevel !== 'ORGANIZATION';
      }).length > 0;
    }

    function _initProvider() {
      var orgSettings = _.find(vm.referralSettingsList, function (rs) {
        return rs.settings.accessLevel === 'ORGANIZATION';
      });
      //if ONLY an org level referral exists, just show it.
      var orgLevelOnly = orgSettings && vm.referralSettingsList.length === 1 && !$stateParams.group && !$stateParams.pc;
      if (orgLevelOnly) {
        vm.selectedReferralSettings = orgSettings;
        vm.organizationId = orgSettings.organization.id;
        vm.view = 'form';
      } else if ($stateParams.group || $stateParams.pc) {
        _resolveForm();
      } else {
        //else show the list
        vm.view = 'list';
      }
    }

    function _onInvalidForm() {
      $translate.use(languageSvc.getLanguage()).then(function () {
        var errorMessage = $translate.instant('referrals.formNotFound');
        errorRouter.navigateError({
          message: errorMessage,
          errorCode: 404
        });
      });
    }

    function _resolveForm() {
      //else if there are resolution parameters to filter to a specific subform, try it
      referralSvc.getReferralSettings($stateParams.organization, $stateParams.group, $stateParams.pc).then(function (resp) {
        vm.selectedReferralSettings = resp;
        if (!resp || !resp.settings) {
          _onInvalidForm();
        }
        vm.view = 'form';
      });
    }

    function _goAgain() {
      //clear the custom field entries
      angular.forEach(vm.selectedReferralSettings.settings.referralCustomFields, function (field) {
        field.fieldResponse = '';
      });
      vm.view = 'form';
    }

    function _select(form) {
      $stateParams.pc = _.get(form, 'settings.accessCodes[0].accessCode');
      $stateParams.group = _.get(form, 'settings.accessCodeGroup.shortName');
      $stateParams.organization = _.get(form, 'organization.shortName');

      $state.go('referral', $stateParams, {
        notify: false
      });
      _validateProvider();
      vm.selectedReferralSettings = form;
      vm.view = 'form';
    }

    function _complete() {
      $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
      vm.view = 'complete';
    }

    function _returnToList() {
      vm.view = 'list';
      $stateParams.pc = null;
      $stateParams.group = null;
      $state.go('referral', $stateParams, {
        notify: false
      });
      vm.selectedReferralSettings = null;
    }
  }
})();